var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCareer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 615.6 343.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bde8f9;}.cls-2{fill:#8bd4ea;}.cls-3{fill:#8fddef;}.cls-4{opacity:0.3;}.cls-5{fill:#fff;}.cls-6{fill:#074066;}.cls-7{fill:#ffeddc;}.cls-8{fill:#e0a469;}.cls-9{fill:#688ca0;}.cls-10{fill:#06457a;}.cls-11{fill:#f7a180;}.cls-12{fill:#dd685f;}.cls-13{fill:#db836e;}.cls-14{fill:#381c0d;}.cls-15{fill:#191126;}.cls-16{fill:#60371b;}.cls-17{fill:#492812;}.cls-18{fill:#704525;}.cls-19{fill:#895830;}.cls-20{fill:#ea9378;}.cls-21{fill:#eab049;}.cls-22{fill:#f4be69;}.cls-23{fill:#d69d41;}.cls-24{fill:#f2d5bd;}.cls-25{fill:#33131b;}.cls-26{fill:#421922;}.cls-27{fill:#3d1720;}.cls-28{fill:#441b27;}.cls-29{fill:#33141d;}.cls-30{fill:#491e2a;}.cls-31{fill:#0a596b;}.cls-32{fill:#0f6472;}.cls-33{fill:#e9f0f4;}.cls-34{fill:#e89277;}.cls-35{fill:#33121c;}.cls-36{fill:#e59177;}.cls-37{fill:#08141e;}.cls-38{fill:#102233;}.cls-39{fill:#384754;}.cls-40{fill:#404f5e;}.cls-41{fill:#0f6482;}.cls-42{fill:#a57141;}.cls-43{fill:#93623a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 482.05,
    height: 199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.01,
    y: 124.22,
    width: 46.13,
    height: 74.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.37,
    y: 37.5,
    width: 16.53,
    height: 101.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 77.48,
    y: 67,
    width: 34.6,
    height: 131.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 111.61,
    y: 20.33,
    width: 45.75,
    height: 178.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 436.38,
    y: 19.33,
    width: 45.75,
    height: 178.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 186.96,
    y: 20.42,
    width: 24.42,
    height: 178.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 210.07,
    y: 71.75,
    width: 32.95,
    height: 127.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 239.94,
    y: 48.42,
    width: 28.48,
    height: 150.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 268.17,
    y: 104.43,
    width: 44.88,
    height: 94.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 310.29,
    y: 53.43,
    width: 66.27,
    height: 145.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "444.37 74.33 371.77 112 371.77 198.95 445.29 198.95 444.37 74.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "77.5 41.71 22.08 63.71 21.87 198.96 77.5 198.96 77.5 41.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 152.4,
    y: 77.83,
    width: 48.4,
    height: 120.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 250.69,
    y: 77.83,
    width: 48.4,
    height: 120.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 324.81,
    y: 67.67,
    width: 35.73,
    height: 131.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 369.81,
    y: 123.5,
    width: 27.33,
    height: 75.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 405.48,
    y: 141,
    width: 74.53,
    height: 57.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 432.54,
    y: 117.33,
    width: 35.73,
    height: 70.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 65.2,
    y: 116.5,
    width: 48.4,
    height: 82.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 84.82,
    y: 92.17,
    width: 16.45,
    height: 89.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.8,
    y: 62.33,
    width: 24.13,
    height: 136.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5.85,
    y: 103.01,
    width: 28.4,
    height: 95.92
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "86.13 0 0 113.28 0 143.34 108.98 0 86.13 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "218.33 0 67.03 199 89.88 199 241.18 0 218.33 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "341.31 0 190.01 199 212.87 199 364.16 0 341.31 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "482.05 40.42 361.49 199 384.34 199 482.05 70.48 482.05 40.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "387.99 0 236.7 199 282.42 199 433.71 0 387.99 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "148.01 0 0 194.68 0 199 46.28 199 197.57 0 148.01 0"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 542.57,
    cy: 51.47,
    r: 43.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 542.57,
    cy: 51.47,
    r: 37.89
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "545.46 51.36 545.47 66.05 543.63 76.04 542.85 65.87 544.16 51.23 545.46 51.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "544.04 50.91 545.41 50.28 540.6 34.13 532.99 23.6 536.03 35.66 544.04 50.91"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 544.67,
    cy: 50.88,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 542.57,
    cy: 16.8,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 519.64,
    cy: 28.24,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 520.29,
    cy: 75.65,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 565.55,
    cy: 27.46,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 567.87,
    cy: 73.12,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 542.57,
    cy: 85.8,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 508.73,
    cy: 51.47,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 576.02,
    cy: 51.47,
    r: 2.52
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M228.29,244.13s-18.19,71.46-13.72,72.42,19.78-70.67,19.78-70.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M287.48,244.07s18.19,71.47,13.72,72.43-19.78-70.67-19.78-70.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224,240.77s-5-69.73-4.4-73.55,21.92-8.79,30.94-9,15.65-.16,19,.19c3.52.36,23.55,1.52,24.7,8.79,1.21,7.64-3.55,74.27-3.55,74.27s-21.82,3.09-35.26,2.91C245.77,244.27,224,240.77,224,240.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M225.7,239.37a9.29,9.29,0,0,0-4.91-.18c-2.09.73-2.55,6.64.09,9.27s17.36,5.27,36.44,4.91,34-2.36,37.45-5.45.72-9.64-3.09-9.27-12.54,4.72-32.9,4.18S227.7,239.92,225.7,239.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M267.25,151.62c-1.59,5.92-13-1.17-13.38-1.74l.24-8.37h0l-3.7-6a.83.83,0,0,0-.4-.32c3.06-.46,2.88-3.56,2.91-3.78l13.77,0c.86,2.65,2.23,4.36,3.07,4.71C269.47,139.54,267.25,151.62,267.25,151.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M266.12,124.73s1.47,9.76,1.29,12.31c-.62,8.75-14.55,4.54-14.36,1.94.06-.83-.09-8.21-.08-9.14.1-5.4.11-8.74.1-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M266.23,125.6s-1.49,2.47-5.65,2.89-7.69-2.79-7.69-2.79.12,2.32,0,5.86c0,1.22,5.83.12,7.32-.49C265.6,128.88,266.23,125.6,266.23,125.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "269.3 133.18 269.3 133.18 269.3 133.18 269.3 133.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M257.87,129.74s2.67.54,7.64-3.69c3.67-3.13,5.48-7,5.83-6.72.78.59,2.75.47,4.18-4.11,1.28-4.09.08-5.77-.89-6-.75-.2-1.77,1.13-1.77,1.13s4.78-21.07-11.4-22.23c-20.15-1.44-17.82,16.07-17.14,21.92,0,0-2.06-3.1-3.06-.22s1,8.56,3.22,8.82c.2,0,1.48-.31,1.52-.25C246.79,119.45,250.73,128.63,257.87,129.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M244,112.78a1.54,1.54,0,0,0-.13,1.74c.56.92.08,1.2-.52.74s-1.32-3.25-.85-3.88S244,112.13,244,112.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M273.17,113.15a1.53,1.53,0,0,1,0,1.74c-.63.89-.17,1.2.46.78s1.54-3.15,1.11-3.81S273.17,112.5,273.17,113.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M255,120.78s1,1.24,3.65,1.18a5.46,5.46,0,0,0,3.79-1.3s-.65,2.15-4.07,2S255,120.78,255,120.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M257.45,117.13s-.21.79.87,1.33c.87.43,1.63-1.15,1.63-1.15a1.94,1.94,0,0,1-1.58.51A1.14,1.14,0,0,1,257.45,117.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M258.1,118.33l-.72-.64a1,1,0,0,1-.28-1,16.59,16.59,0,0,0,.92-4.61,12.13,12.13,0,0,1-.36,4C257.48,116.92,257.13,117,258.1,118.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 250.14,
    cy: 115.98,
    r: 2.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 267.27,
    cy: 116.29,
    r: 2.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M255.45,108.13a37.31,37.31,0,0,0-5.7-.4,6.41,6.41,0,0,0-1.92.74c-1.53.9,2.67,1,4.1,1.32.95.18,3.57.42,3.67-.17S255.79,108.31,255.45,108.13Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 251.74,
    cy: 111.93,
    rx: 1.18,
    ry: 1.27,
    transform: "translate(-13.69 38.1) rotate(-8.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M255,112.91a3.61,3.61,0,0,0-2.63-2.19,5.61,5.61,0,0,0-3.88.92l.87.48a2.67,2.67,0,0,1,2.11-1.18C252.93,110.88,255,112.91,255,112.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M261.88,108.05a36.19,36.19,0,0,1,5.71-.35,6.56,6.56,0,0,1,1.91.75c1.52.92-2.68,1-4.11,1.28-1,.18-3.58.4-3.67-.19S261.54,108.23,261.88,108.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 265.56,
    cy: 111.88,
    rx: 1.27,
    ry: 1.18,
    transform: "translate(114.03 356.99) rotate(-81.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M262.29,112.84a3.62,3.62,0,0,1,2.65-2.17,5.61,5.61,0,0,1,3.88,1l-.89.47a2.63,2.63,0,0,0-2.09-1.19C264.38,110.82,262.29,112.84,262.29,112.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M274.49,91.37c-2.12,2.06-9.23-5.17-15.73-4.54A32.3,32.3,0,0,0,246,90.57c-3.2,1.54-2.73,18.21-2.29,18.64s.66.79.66.79l0-.06c.63,3.23,1.08,6.64,1.57,7.19a1.09,1.09,0,0,0,1.42.31s-.38-3.42-.45-7.87c0-3.1.85-4.39,1.43-4.88l.79-.66c1.57-.75,3.82-7.55,9.72-7.8,4.82-.21,7.81,6.69,9.63,7.58a8.76,8.76,0,0,1,1.95,5.76c-.07,4.45-.45,7.87-.45,7.87a1.09,1.09,0,0,0,1.42-.31c.47-.53.91-3.72,1.51-6.84.14-.18,1.06-1.29,1.75-1.11C274.88,109.25,277.78,88.19,274.49,91.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M267.34,100.79s-2.12,4.24-11.46,5.41-11.25,1.8-13.26-.53-4.46-12.84-2.76-11.25,3.22-2.52,4.92-5.27,12.38-6.65,14.82-4.85S269.78,98.35,267.34,100.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M241.4,213s7.26,3.56,20.61,2.92,19.22-1.35,19.22-1.35,4.27,10,6.62,13.79-1.11,6.48-2.58,10.66-15.63,7.32-20.92,6.34-12.49,2.48-19,1.84C234,246.12,234.59,237,233.71,233.6,233,230.93,240.51,214.1,241.4,213Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M254.21,301.35s.6,11,2.19,16.22,2.77,5.33.71,8.27-5.09,10.83-12.3,12.24-11.35,1.58-12.08.46.82-3.06.82-3.06,14.2-5.74,16.93-9.45S254.21,301.35,254.21,301.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M245.3,303s-1.36,14.38-6.48,22.68-6.92,11.67-5.25,12.45,9.37.8,14.73-3.9,6.77-10.61,7.47-16.93-.86-14.59-.86-14.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M257.81,310.71s-.8-84.27-9.38-93.13-17.81-5.25-20,4.7c-3.82,17.46,11.68,85.24,12.34,91.71S257.68,315.68,257.81,310.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M201,253.29s-9.64,5.31-14.92,6.75-6,.47-7.39,3.78-6.48,10.06-3.85,16.92,4.67,10.46,6,10.48,2.16-2.31,2.16-2.31-2.66-15.09-1-19.37S201,253.29,201,253.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M204.28,261.74s-11.48,8.77-15.8,17.51-6.22,12.06-7.77,11.06-5.65-7.52-4.51-14.56,5.41-11.37,10.4-15.31,12.83-7,12.83-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M191.73,255.37s75.2-38,87-34.49,12.85,13.4,5,19.91C270,252.21,202.7,269.62,196.65,272S187.38,257.78,191.73,255.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M245.24,152l-.11-14.66c-7.09,2.25-14.53,5.22-15.84,8.63-4.83,12.52-16.18,43.32-16.59,44.65-1,3.27,13.29,8.82,13.58,6.08.27-2.57,3.19-10.27,7.07-20.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M247.64,203s-6.69-6.19-11.95-10.31-11-8.13-14.18-8.37-10.86,2-8.7,11.67c1.24,5.56,13.82,7,20.8,9.87s16.28,5.12,17.25,5S249.69,204.12,247.64,203Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M276.42,157.94l14.79,33.64c7.18,3.26,9.8,0,12.58,2.9-.13-4.37-12.39-48.13-16.49-51.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M303.57,193.32s2.79,5.29-10.93,9.69-14.87,3.68-19.71,7.17-.74-6.88-.74-6.88,13.32-11.62,18.54-13.53S299.36,188.39,303.57,193.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M279.2,185.82c.29-4.58,2.27-18.53,2.27-18.53S294.59,146,285.76,142c-7.84-3.62-17-8.12-17-8.12a12,12,0,0,1-9.09,4.69,8.1,8.1,0,0,1-8.06-5.3c-12,5.28-13.8,7.56-19.64,10-3.69,1.55,3.69,23.58,3.69,23.58.29,1.33,2.52,11,2.52,11s.56,4,.67,5.55c.53,7.49-2.84,26.77-2.84,26.77s8.35,6.64,22.92,5.66,24.6,1.25,23.74-1.56S278.66,194.31,279.2,185.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M252.31,132.16l-1.77,2.33s3.11,6,9.48,5.45a13.8,13.8,0,0,0,9.69-5.66l-2.4-2.26s-1.35,2.83-6.72,3.46A9.24,9.24,0,0,1,252.31,132.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M251.89,133.22s-19.24,7.25-21.84,9.58-11.29,21.76-11.2,24.3,14.15,10,15.49,10S247,153.84,247,153.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M219.56,164.13a72,72,0,0,0,16.62,10.75L234,178.24a58.38,58.38,0,0,1-10.5-4.88c-5.84-3.39-6.1-5.2-6.1-5.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "237 173.15 239.65 166.47 238.46 179.16 237 173.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M268.35,139.22a2.9,2.9,0,0,1,3.9-3.28c5.89,2.32,15.14,6.11,16.89,7.68,2.6,2.33,9.81,19.95,9.71,22.49s-14,8.88-15.35,8.88-11.95-20.05-11.95-20.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M297.6,161.28A72.18,72.18,0,0,1,281,172l2.16,3.36a59.13,59.13,0,0,0,10.51-4.88c5.83-3.4,5.64-4.9,5.64-4.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "281.1 171.95 278.06 166.11 279.9 179.83 281.1 171.95"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 230.65,
    y: 178.77,
    width: 57.2,
    height: 37.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 259,
    cy: 197.58,
    rx: 4.52,
    ry: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M78.66,243.87S60.48,315.33,65,316.29s19.78-70.67,19.78-70.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M137.86,243.81s18.18,71.47,13.72,72.43-19.78-70.67-19.78-70.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M74.39,240.51S69.37,170.78,70,167s21.93-8.79,31-9,15.64-.16,19,.19c3.51.36,23.54,1.52,24.69,8.79,1.21,7.64-3.54,74.27-3.54,74.27s-21.82,3.09-35.27,2.91C96.15,244,74.39,240.51,74.39,240.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M76.07,239.12a9.23,9.23,0,0,0-4.91-.19c-2.09.73-2.54,6.64.1,9.27s17.35,5.27,36.44,4.91,34-2.36,37.44-5.45.73-9.64-3.09-9.27-12.54,4.72-32.9,4.18S78.07,239.66,76.07,239.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M89.6,139.59s10.56,4.78,19.76,5,15.56-6.53,15.56-6.53,1.11-26.28-1.47-32-14.22-7.9-14.22-7.9L94.3,102.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M121.18,144.68c-2-.35-4.31-1.15-5.49-2.51-.65-.75-1.19-3.47-1.26-4.48,0-.64-.07-1.11-.09-1.3l-.4-4.06H102.58s-.14,3.16-.21,5.68h0s-.35,3-1,3.82c-1.93,2.11-7.32,3.83-7.32,3.83-.07,3-.55,18.79,13.66,18.79C121.23,164.45,123.55,145.09,121.18,144.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M102.54,132.57l-.2,5.62a11.51,11.51,0,0,0,6.37.38c3.56-.8,6-5.74,6-5.74s-11.09.65-12.14-.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M108.43,136.21s2.63.52,7.46-3.89c3.57-3.26,4.89-7.15,5.4-6.91,0,0,2.72.08,4.14-4.08s.46-5.88-.49-6.14c-.75-.2-2,.93-2,.93s5.26-21.36-11.48-22.57c-19.81-1.43-19,16.14-18.25,22.12,0,0-1.63-2.11-2.46.59-.91,3,2.32,8.74,4.53,9a9,9,0,0,1,1-.09C97,126.23,101.39,135.18,108.43,136.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M93.48,119.1a1.61,1.61,0,0,0,0,1.78c.62.9.17,1.22-.45.8s-1.56-3.2-1.15-3.88S93.47,118.43,93.48,119.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M123.07,119.22a1.61,1.61,0,0,1,0,1.78c-.61.92-.15,1.23.47.79s1.47-3.24,1-3.91S123.06,118.55,123.07,119.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M105.46,127.85s.86.89,3.39.86a5.28,5.28,0,0,0,3.65-1.2s-.65,2-3.92,1.92S105.46,127.85,105.46,127.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M107.54,123.67s-.22.82.91,1.39c.91.45,1.7-1.2,1.7-1.2a2,2,0,0,1-1.64.54A1.21,1.21,0,0,1,107.54,123.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M108.22,124.93l-.75-.67a1,1,0,0,1-.29-1.06,17.52,17.52,0,0,0,1-4.81,12.57,12.57,0,0,1-.38,4.14C107.57,123.46,107.21,123.53,108.22,124.93Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 100.05,
    cy: 121.96,
    r: 2.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 117.91,
    cy: 122.29,
    r: 2.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M103.09,114.33a3.94,3.94,0,0,0-1.65-.44,6.1,6.1,0,0,0-2.71.38c-1.08.82,1-.13,3,.83,1.23.58,1.75.85,1.9.29A1,1,0,0,0,103.09,114.33Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 101.08,
    cy: 117.92,
    rx: 1.27,
    ry: 1.37,
    transform: "matrix(0.98, -0.2, 0.2, 0.98, -21.39, 22.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M104.66,118.81a3.88,3.88,0,0,0-3-2.22,6.09,6.09,0,0,0-4.15,1.19l1,.47a2.89,2.89,0,0,1,2.22-1.38C102.32,116.72,104.66,118.81,104.66,118.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M114.1,114.38a4,4,0,0,1,1.67-.37,6,6,0,0,1,2.69.48c1.05.86-1-.17-3.06.71-1.25.53-1.79.79-1.92.22A1,1,0,0,1,114.1,114.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 115.48,
    cy: 118.01,
    rx: 1.37,
    ry: 1.27,
    transform: "translate(-23.46 207.21) rotate(-78.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M111.9,118.88a3.89,3.89,0,0,1,3-2.21,6.08,6.08,0,0,1,4.14,1.21l-1,.47a2.87,2.87,0,0,0-2.22-1.39C114.25,116.8,111.9,118.88,111.9,118.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M121.37,104.59s-6.36,7.76-15.62,7.32S97,117.3,96.6,121.5s2,10.77,2,10.77l-9,7.32s-.76-30,1.07-35.54,9.16-12,16.37-12.6S123.52,99.42,121.37,104.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M116.74,106.17s-1.58,2.3,2.72,7-.71,19.67-.71,19.67l6.17,5.17s3.45-12.64,3.59-23.41-6-21.68-11.34-20.82S116.74,106.17,116.74,106.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M79.48,229l27.36,4s11.22-4.68,12.39-4.68,17.07,7.25,17.77,3c.45-2.71-5.6-13.28-10.34-22.27A55.25,55.25,0,0,1,106,212.45a35.15,35.15,0,0,1-17.1-4.71c-.73,1.62-1.6,3.44-2.64,5.57C82.29,221.49,79.48,229,79.48,229Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M86.89,249.16s-9.36-5.61-8.89-14.5,9.35-17.14,17.3-15,14.65,6.86,15.75,9.19S96.71,250.87,86.89,249.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M105.12,230.45s9-8.57,17.93-8.88,13.87,7.79,14.18,11.69-1.71,15.43-11.38,17-22.75-3.43-23.69-6.24S105.12,230.45,105.12,230.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M63.35,299.54S62.31,296.16,52,311c-2.26,3.25-1.61,15.23-.32,19.49,1.89,6.24,6.51,7,6.88,4.34,2.24-16.08,9.59-20.57,11-32.88S63.35,299.54,63.35,299.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M53,309.41s-4.8,6.89-4.8,8.51-.21,3,.43,3,6-6.13,6-6.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M56,301.55s25.3-68.61,35-74.42,17.65,1.07,15.73,11.17c-3.38,17.72-35,66.5-37.84,72.44S54.34,306.31,56,301.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M94.61,306.36s-2-2.92-7.54,14.31c-1.22,3.76,2.89,15,5.37,18.74,3.62,5.41,8.26,4.79,7.84,2.15-2.54-16,3.19-22.47.94-34.66S94.61,306.36,94.61,306.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M87.57,318.82s-2.57,8-2.1,9.54.67,2.95,1.29,2.76,4-7.63,4-7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M89,309.88s17.77-76.89,26.57-84,16.31.76,15.86,11c-.79,18-26.27,74.7-28.21,81S88,314.83,89,309.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M116.48,141.68s-2.81,3.51-8.66,3-7.94-2.34-7.94-2.34-8.89,3.51-13.8,4.21,2.11,17.53,2.11,17.53l19.87-5.84,21.27,6.55s5.23-15.36,3.59-16.29S122.09,145,116.48,141.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M88,209.89c2.61-5,4.83-9.45,5.33-11.87,1.4-6.78-5.14-33.9-5.14-33.9l19.17-11.22s22.68,6.55,22,11.93-6.54,29-6.54,33.19c0,3.12.9,6,3,10.57a35.22,35.22,0,0,1-17.09,4.71A55.36,55.36,0,0,1,88,209.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "128.05 171.84 124.54 162.72 127 176.4 128.05 171.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "90.07 172.96 91.86 165.06 92.22 182.79 90.07 172.96"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 108.32,
    cy: 145.26,
    rx: 1.85,
    ry: 1.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M115,140.4s3.09.07,3.52,2.72-1.73,6.25-5.82,4.46-3.8-3-3.8-3S114,143.12,115,140.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M101.21,140.5s-3.08.08-3.52,2.73,1.73,6.25,5.82,4.45,3.81-2.94,3.81-2.94S102.22,143.23,101.21,140.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M132.92,148.54s4.21,2.65,6.86,9.66,16.05,38.19,14.8,40.21-4.2,5.62-7.32,4.37-22.45-36.32-24.47-40.53S124.5,147.29,132.92,148.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M122.26,209.76s-5.71-1.58-6.4-1.41-7.36,1.43-10.43,1.92-4.71.88-4.51,2.26,3.5.52,6.47.07a21.41,21.41,0,0,1,3.94-.39s-6.29.83-8.19,1.61c-2.06.84-1.9,1.94-.77,2.33s8.46-1.49,9-1.35-5.79,1.31-6.87,1.73a1,1,0,0,0,.3,2c1.11.18,7.07-1.46,7.55-1.18s-4.69,1.1-5.3,1.25,0,1.18.87,1.42a25.29,25.29,0,0,0,7.11-.53,53.33,53.33,0,0,0,8.89-4.59C124.79,214.17,123.48,210.21,122.26,209.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M122.23,213.37c.15-2.72-2.73-3.45-.71-5,7.59-5.64,21.74-15.78,26.44-16.32,5.92-.68,6.29,2.9,6.85,5.66.36,1.79-7,9.54-16.56,13.11s-13,4.58-15.3,5.09C122.38,216.09,122.2,214.05,122.23,213.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M84.94,146.91a3,3,0,0,0-1.64,1.2,42.49,42.49,0,0,0-6.44,16.8c-1.17,7.41-5.29,38.42-3.54,40s5.59,4.24,8.25,2.19,10.69-41.23,11.48-45.83C93.81,156.9,91.93,145,84.94,146.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M115.55,208.28s5.54-2.11,6.24-2,7.47.75,10.56.95,4.77.45,4.71,1.84-3.45.84-6.44.66a23,23,0,0,0-4,0s6.34.24,8.31.84c2.12.65,2.07,1.76,1,2.26s-8.56-.71-9.09-.51,5.88.76,7,1.09a1,1,0,0,1-.11,2c-1.1.27-7.18-.81-7.64-.49s4.78.66,5.41.76.15,1.17-.75,1.5a25.41,25.41,0,0,1-7.13.12,52,52,0,0,1-9.26-3.75C113.44,212.89,114.38,208.83,115.55,208.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M116.56,207.81S83.78,194.83,78,196s-5.16,7.2-5,8.93,9.94,7.52,20.16,8,19.77,1.57,22.1,1.34S116.56,207.81,116.56,207.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M377.91,244.39s-18.18,71.46-13.72,72.42S384,246.14,384,246.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M437.1,244.33s18.19,71.47,13.72,72.43S431,246.09,431,246.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M373.63,241s-5-69.73-4.4-73.55,21.93-8.8,30.94-9,15.65-.16,19,.18c3.51.37,23.54,1.53,24.69,8.8,1.21,7.64-3.55,74.27-3.55,74.27s-21.81,3.09-35.26,2.91C395.39,244.53,373.63,241,373.63,241Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M375.32,239.63a9.29,9.29,0,0,0-4.91-.18c-2.09.73-2.54,6.64.09,9.27S387.86,254,407,253.63s34-2.36,37.44-5.45.73-9.64-3.09-9.27-12.54,4.72-32.9,4.18S377.32,240.18,375.32,239.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M388.12,103.59s-2.44,16.34-.75,18.36,12.84,5.09,17.94,4.35,11.88-1.49,13.68-2.76-.21-18.68-.85-20.9S394.16,91.81,388.12,103.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M412.32,152.72c-1.58,5.93-13-1.17-13.37-1.74l.23-8.36h0l-3.7-6a.82.82,0,0,0-.39-.32c3.06-.45,2.87-3.55,2.9-3.78l13.77,0c.86,2.65,2.23,4.36,3.07,4.71C414.54,140.64,412.32,152.72,412.32,152.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M411.19,125.83s1.47,9.77,1.29,12.31c-.62,8.76-14.54,4.55-14.35,1.94.06-.83-.1-8.2-.08-9.13.09-5.41.1-8.74.09-5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M411.3,126.7s-1.49,2.48-5.65,2.9-7.68-2.8-7.68-2.8.12,2.32,0,5.86c0,1.22,5.83.12,7.32-.49C410.68,130,411.3,126.7,411.3,126.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "414.37 134.28 414.37 134.28 414.37 134.28 414.37 134.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M403,130.85s2.66.54,7.63-3.7c3.67-3.13,5.48-7,5.83-6.71.78.59,2.76.47,4.19-4.12,1.27-4.09.07-5.77-.89-6-.76-.21-1.78,1.13-1.78,1.13s4.78-21.08-11.4-22.24c-20.14-1.43-17.82,16.07-17.14,21.92,0,0-2.06-3.09-3.06-.22s1,8.57,3.23,8.82c.19,0,1.47-.31,1.51-.24C391.86,120.55,395.8,129.73,403,130.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M389,113.88a1.54,1.54,0,0,0-.13,1.74c.56.93.08,1.21-.52.75s-1.31-3.25-.84-3.88S389.08,113.23,389,113.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M418.25,114.26a1.53,1.53,0,0,1,0,1.74c-.63.88-.16,1.19.47.78s1.53-3.15,1.11-3.81S418.24,113.6,418.25,114.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M400.05,121.89s1,1.24,3.65,1.17a5.42,5.42,0,0,0,3.78-1.29s-.65,2.15-4.06,2S400.05,121.89,400.05,121.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M402.52,118.23s-.21.79.87,1.33c.87.44,1.64-1.14,1.64-1.14a2,2,0,0,1-1.58.51A1.15,1.15,0,0,1,402.52,118.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M403.17,119.44l-.72-.64a1,1,0,0,1-.27-1,17.07,17.07,0,0,0,.91-4.62,11.81,11.81,0,0,1-.36,4C402.55,118,402.21,118.1,403.17,119.44Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 395.21,
    cy: 117.09,
    r: 2.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 412.34,
    cy: 117.4,
    r: 2.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M400.52,109.23a37.31,37.31,0,0,0-5.7-.4,6.65,6.65,0,0,0-1.92.75c-1.52.9,2.67,1,4.1,1.31,1,.19,3.57.42,3.68-.16S400.87,109.42,400.52,109.23Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 396.81,
    cy: 113.04,
    rx: 1.18,
    ry: 1.27,
    transform: "translate(-12.28 59.37) rotate(-8.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M400.07,114a3.59,3.59,0,0,0-2.63-2.19,5.61,5.61,0,0,0-3.88.92l.88.48a2.67,2.67,0,0,1,2.11-1.18C398,112,400.07,114,400.07,114Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M407,109.15a37.3,37.3,0,0,1,5.7-.35,6.52,6.52,0,0,1,1.91.76c1.52.91-2.68,1-4.11,1.28-.95.18-3.57.39-3.67-.19S406.61,109.33,407,109.15Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 410.64,
    cy: 112.99,
    rx: 1.27,
    ry: 1.18,
    transform: "translate(235.61 501.26) rotate(-81.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M407.37,113.94a3.59,3.59,0,0,1,2.65-2.17,5.61,5.61,0,0,1,3.87,1l-.88.47a2.66,2.66,0,0,0-2.1-1.2C409.45,111.92,407.37,113.94,407.37,113.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M405,99.24s-3.29,6.69-8.92,7.75-3.5,8.17-4.45,9.44-1.06-.32-1.49-1.38a56.26,56.26,0,0,1-2.54-9.23c-.22-2.34-2.66-6.9-.75-8.7s4-3.93,4.46-7.11,4.24-5.09,7.75-3.4,3,.85,6-.1S406.68,98.07,405,99.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M402.76,99.56s3.29,6.68,8.91,7.74,3.5,8.17,4.46,9.45,1.06-.32,1.48-1.38a55.19,55.19,0,0,0,2.55-9.23c.21-2.34,2.65-6.9.74-8.7s-4-3.93-4.46-7.11-4.24-5.09-7.74-3.4-3,.85-6.05-.1S401.06,98.39,402.76,99.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M400.5,117.42h-6.57a1.58,1.58,0,0,1-1.57-1.57v-3.22a1.58,1.58,0,0,1,1.57-1.58h6.57a1.58,1.58,0,0,1,1.57,1.58v3.22A1.58,1.58,0,0,1,400.5,117.42Zm-6.57-5.52a.73.73,0,0,0-.72.73v3.22a.72.72,0,0,0,.72.72h6.57a.72.72,0,0,0,.72-.72v-3.22a.73.73,0,0,0-.72-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M413.72,117.24h-6.56a1.57,1.57,0,0,1-1.57-1.57v-3.22a1.57,1.57,0,0,1,1.57-1.57h6.56a1.57,1.57,0,0,1,1.58,1.57v3.22A1.57,1.57,0,0,1,413.72,117.24Zm-6.56-5.51a.72.72,0,0,0-.72.72v3.22a.72.72,0,0,0,.72.72h6.56a.73.73,0,0,0,.73-.72v-3.22a.73.73,0,0,0-.73-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M401.81,114.28l-.49-.69a4.5,4.5,0,0,1,4.89-.17l-.47.71A3.63,3.63,0,0,0,401.81,114.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M424.27,186.92c.29-4.57,2.27-18.53,2.27-18.53s13.12-21.27,4.3-25.34c-7.85-3.62-17-8.11-17-8.11a12,12,0,0,1-9.09,4.69,8.12,8.12,0,0,1-8.06-5.31c-12,5.28-15.53,6.28-21.37,8.73-3.69,1.55,5.43,24.86,5.43,24.86.29,1.33,2.52,11,2.52,11s0-.14,0-.37c.29,2.3,1.49,11.87,1.6,13.41.54,7.49-1.06,30.14-1.06,30.14s6.23,2,20.8,1.06,24.21,3.44,23.34.63S423.73,195.42,424.27,186.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "380.78 167.91 382.93 163.93 382.82 176.34 380.78 167.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "426.57 169.12 424.42 165.13 424.89 178.99 426.57 169.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M388.89,152.7l-1.65-14.43c-7.1,2.25-14.54,5.22-15.85,8.64-4.83,12.51-16.3,46.08-16.71,47.4-1,3.27,14.58,7.05,14.88,4.31.27-2.57,4-11.36,7.85-21.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M421.49,159.05,435,190.31c7.17,3.26,10.64,2.39,13.41,5.27-.13-4.37-12-48.12-16.06-51.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M389.64,204.15s-6.7-6.2-11.95-10.31-11-8.14-14.18-8.38-10.86,2-8.7,11.67c1.24,5.56,13.82,7,20.79,9.87s16.28,5.13,17.26,5S391.69,205.22,389.64,204.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M389.64,205.11a51.8,51.8,0,0,1,5.8-1c.7.1,7.9-.22,11,0s4.77.44,4.7,1.83-3.44.84-6.43.67a22.62,22.62,0,0,0-4,0s6.34.25,8.3.85c2.13.64,2.07,1.75,1,2.25s-8.56-.71-9.09-.51,5.88.76,7,1.09a1,1,0,0,1-.11,2c-1.1.27-7.18-.81-7.64-.49s4.78.66,5.4.76.15,1.17-.74,1.5a25.41,25.41,0,0,1-7.13.12,52.12,52.12,0,0,1-9.27-3.75C387.53,209.73,388.47,205.67,389.64,205.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M448.82,200.76s-2.59,5.39-14.28-3S422.73,188,417,186.17s5.1-4.69,5.1-4.69,17.26,3.79,21.9,6.85S450.29,194.45,448.82,200.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M418.85,177.07s-2.19-4.83-2.51-4.62-.64,5.41-.64,5.41l3.15-.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "389.18 159.01 388.05 200.32 416.13 201.45 416.91 159.58 389.18 159.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M422.83,181.91s-3.6-4.71-4.25-5-6.74-3.29-9.47-4.75-4.29-2.13-5-.91,2.48,2.53,5.12,3.95a22,22,0,0,1,3.38,2.06s-5.52-3.12-7.51-3.65c-2.15-.57-2.68.4-2,1.4s7.65,3.91,8,4.36-5.41-2.45-6.53-2.77a1,1,0,0,0-1,1.79c.78.81,6.52,3.09,6.74,3.61s-4.4-1.95-5-2.2-.74.91-.16,1.66a25.62,25.62,0,0,0,6,3.86,53,53,0,0,0,9.85,1.69C422.2,186.94,423.53,183,422.83,181.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M401,302.81s-.28,11,.88,16.35,2.33,5.54,0,8.3-6,10.39-13.26,11.21-11.44.66-12.08-.53a4.4,4.4,0,0,1,0-3s15.72-4.59,18.74-8.06S401,302.81,401,302.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M391.4,302.32s-2.52,14.23-8.29,22.09-7.84,11.06-6.25,12,10.2,2.61,15.92-1.63,6.69-11.1,7.89-17.34.33-14.61.33-14.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M413.52,303.64s.28,11-.87,16.35-2.33,5.54,0,8.3,5.95,10.38,13.25,11.21,11.44.65,12.08-.53a4.43,4.43,0,0,0,0-3s-15.72-4.59-18.75-8.06S413.52,303.64,413.52,303.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M423.13,303.15s2.51,14.23,8.28,22.08,7.85,11.07,6.25,12-10.19,2.61-15.92-1.63-6.69-11.1-7.89-17.34-.33-14.61-.33-14.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M384.51,211.56a75.64,75.64,0,0,0,23.13,2.38c13.35-.61,18.46-4.57,18.46-4.57s4.47,15.25,6.83,18.81,1.21,6.59-.26,10.49-17.95,6.33-23.25,5.41-12.49,2.31-19,1.72c-11.33-1-10.78-9.52-11.66-12.74C378.1,230.57,383.63,212.56,384.51,211.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M402.89,311.81s-.8-84.27-9.38-93.12-17.82-5.25-20,4.7c-3.82,17.46,11.68,85.23,12.33,91.7S402.75,316.78,402.89,311.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M411.41,312.05s.8-84.27,9.38-93.13,17.81-5.25,20,4.7c3.82,17.46-11.68,85.24-12.33,91.71S411.54,317,411.41,312.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M569.14,276.34s-13.7-13.06-12.82-48,27.57-67.88,24.4-89.71,8.52,4.46,7.53,20.77c-1.59,26-7.82,39.26-17,59.43S569.14,276.34,569.14,276.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M571.53,254.47s-16.19-9.6-22.91-43.83,11.08-42.25,4.3-93c-2.91-21.87,4.51-10.78,11.36,4s1.4,54.62-3.21,76.38S571.53,254.47,571.53,254.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M569.13,281.12s-10.74-15.71-2.77-49.65S607.14,171,608.49,149s7,8.78,7.11,25.12S596,207.62,582.86,225.36,569.13,281.12,569.13,281.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M545.67,287.51s10.74-15.71,2.77-49.65-40.78-60.47-42.13-82.5-5.14,5.65-5.29,22,17.8,36.67,30.92,54.41S545.67,287.51,545.67,287.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M542.84,274.08s13.4-13.39,11.72-48.26-29.12-67.19-26.46-89.1-7-9.3-10.06,6.72,11.73,53.3,21.41,73.23S542.84,274.08,542.84,274.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "578.44 315.81 534.81 315.81 529.18 236.03 583.66 236.24 578.44 315.81"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 524.17,
    y: 232.27,
    width: 63.67,
    height: 9.82
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/career.ee726e14aba7062d1991751c9c2e95b7.svg";
export { ForwardRef as ReactComponent };